/* LKC wishlist page + account block, T6.31 (16 Sep 2026). Needs assets/lkc-wishlist.js (window.LKCWishlist).
   Roots: [data-lkc-wl-page] in sections/wishlist.liquid and sections/customer-saved-items.liquid.
   Server-rendered cards stay put; the grid is matched to LKCWishlist.list(): items no longer saved are
   removed, saved items not on the page yet get a skeleton filled from
   /products/<handle>?section_id=wishlist-item (the real product card, 6 requests at a time, redirects
   followed for renamed products). Unavailable products are hidden with a note.
   T6.31b (17 Sep 2026): on the shopper's own list the card heart is an X that removes the item (drawn by
   lkc-wishlist-page.css, named here; the Remove text buttons are gone). "Share wishlist" copies
   https://<host>/pages/wishlist?shared=<handles>. A root with data-shared (set by the inline script at the top
   of sections/wishlist.liquid, which also checks the handles) shows those products instead with normal save
   hearts, and never reads or writes the viewer's own list.
   T6.31c (17 Sep 2026): lean cards (snippets/wishlist-card.liquid) with Colour / Size / Fit selects and an Add to cart
   button, driven from each card's data-wl-v JSON (parsed the first time the card is used). Add to cart posts
   cart/add.js with sections=cart-drawer and then does what the quick-add modal does after an add
   (QuickView.addtocart in component-quick-view.js): drawer form and count swapped from the section, drawer and overlay
   opened, PromotionalProgressbar.recalculate, CartDrawerUpsell.load, QuickView.load, checkout button locked meanwhile.
   That method cannot be called directly because it reads and writes the modal's own form and button. "Set size,
   colour or fit for all" (snippets/lkc-wishlist-setall.liquid) sets a value on every card that has it and remembers
   it in localStorage "lkc.wl.pref" for cards shown later. The old product card quick-add pill and swatch wiring is gone.
   T6.31c review fixes (17 Sep 2026): adds from different cards go one at a time (checkout stays locked until the last
   one finishes, so drawer swaps land in click order); a successful add is announced in a hidden status line; the add
   error stays until the shopper changes that card or adds again (no timed collapse); a card whose variant data is
   unreadable offers "View product" instead of a dead button; a select changed before this script started keeps the
   shopper's value over remembered ones; a run of quick panel changes (arrow keys on a closed select fire change at
   every step) is one choice: cards a step changed go back when a later step does not match, and one toast at the end.
   T6.32e (19 Sep 2026), Warwick's feedback: choices only offer what exists. Card selects are Colour, Fit, Size and
   cascade (update()): Fit lists the fits made in the chosen colour, Size the sizes made in the chosen colour and fit,
   sold-out entries stay listed but disabled, and changing an earlier choice clears a later one that is not made (or
   is sold out) with it, so the button asks for it again. Every card is brought in line as soon as it is shown (it
   used to wait for the first touch). Set for all offers only values the shown cards have, cascades the same way, shows
   "M (4 of 6)" counts, and only sets a value on cards where the whole resulting choice exists. Add to cart shows the
   product page loading state (js-loading: the sloth) while adding. The share link from a preview theme carries
   preview_theme_id so it opens that preview (the live theme link is unchanged).
   T6.32e review fixes (19 Sep 2026): a fit or size the shopper picked comes back when an earlier choice makes it again
   (st.pick), and a cleared or auto-picked choice is read out in the status line. Set for all works like the cards: a
   value only has to be made (in stock) with the choices before it on each card, later ones are cleared where not made,
   so no colour is blocked by a fit or size; each list is what some card would take, counted "of" the cards that have
   that choice. Over 250 variants the rows run colour by colour, so every colour before the last listed row's colour is
   complete and cascades like any card; only that colour and the ones after it keep the old View product fallback.
   T6.32f (20 Sep 2026), Warwick: "the colour / fit dropdowns dont change how the product image looks". The card photo
   now follows the choice. snippets/wishlist-card.liquid adds the variant photos to the card JSON (b / i / m below),
   update() works out which one the current choice lands on, and showShot() swaps it in once it has loaded. */
(function () {
  'use strict';
  var d = document, STEP = 24, CONC = 6, SHARE_MAX = 100, HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/;
  var PREF = 'lkc.wl.pref', KEYS = ['colour', 'fit', 'size'], ADDED_MS = 2000, SETTLE_MS = 500;
  var SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL'];
  /* The letter sizes snippets/wishlist-card.liquid sorts a Size select by (only when every value is one of them) */
  var SIZE_ORDER = 'XXS|XS|S|M|L|XL|XXL|2XL|XXXL|3XL|XXXXL|4XL|XXXXXL|5XL|6XL|7XL'.split('|');
  var SIZE_ALIAS = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL' };
  var SKEL = '<div class="lkc-wl-skel__img"></div><div class="lkc-wl-skel__line"></div><div class="lkc-wl-skel__line lkc-wl-skel__line--short"></div>';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function ALL() { return true; } /* paint(): every value unknown (listed, never disabled) */
  function skeleton() {
    var node = d.createElement('div');
    node.className = 'lkc-wl-item lkc-wl-skel';
    node.setAttribute('aria-hidden', 'true');
    node.innerHTML = SKEL;
    return node;
  }

  /* Card loader for one root. Jobs {h: handle, n: placeholder node} are fetched CONC at a time.
     got(job, card) gets the card element, or null when the section printed its missing marker (deleted,
     unpublished, not sold in this market). A network error, 5xx or unexpected reply is retried once after 2s,
     then lost(job). after() runs each time a request settles. */
  function loader(got, lost, after) {
    var queue = [], active = 0;
    function run(job) {
      active++;
      fetch('/products/' + encodeURIComponent(job.h) + '?section_id=wishlist-item', { credentials: 'same-origin' })
        .then(function (r) { if (r.status >= 500) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          var t = d.createElement('template'), item;
          t.innerHTML = html;
          item = t.content.querySelector('[data-wl-item]');
          if (!item && !t.content.querySelector('[data-wishlist-missing]')) throw new Error('no card');
          got(job, item);
        })
        .catch(function () {
          if (job.retried) { lost(job); return; }
          job.retried = true;
          return new Promise(function (res) { setTimeout(res, 2000); }).then(function () { queue.push(job); });
        })
        .then(function () { active--; after(); });
    }
    return {
      add: function (job) { queue.push(job); },
      pump: function () {
        var job;
        while (active < CONC && queue.length) {
          job = queue.shift();
          if (job.n.parentNode) run(job);
        }
      },
      idle: function () { return !active && !queue.length; }
    };
  }

  /* Own list: the card heart is drawn as an X. Name it for what it does and drop the pressed state
     (assets/lkc-wishlist.js leaves data-wl-x buttons alone and only ever removes with them). */
  function xify(scope) {
    each(scope.querySelectorAll('button.lkc-wh--card[data-wl-id]:not([data-wl-x])'), function (b) {
      var t = (b.getAttribute('aria-label') || '').replace(/^Save\s+/, '');
      b.setAttribute('data-wl-x', '');
      b.removeAttribute('aria-pressed');
      b.setAttribute('aria-label', t ? 'Remove ' + t + ' from wishlist' : 'Remove from wishlist');
    });
  }

  /* ---- T6.31c (17 Sep 2026) lean cards ---- */
  function norm(v) { return String(v == null ? '' : v).trim().toLowerCase(); }
  function toast(msg) {
    var W = window.LKCWishlist;
    if (W && typeof W.toast === 'function') W.toast(msg);
  }
  /* Card state from data-wl-v, parsed the first time the card is used: j = the JSON, n = option count, els[i] = the
     select for option i (null when the option has one value, which is then always the choice), sel[i] = chosen value
     index or -1. Variant rows are [id, value index per option..., available 1/0, price index, compare-at index or -1].
     null for cards without data (Customise) and for data that does not read right (not JSON, or a row whose value
     indexes are missing or out of range): update() then turns the button into View product.
     T6.32e: chain = the option indexes of the selects in card order (Colour, Fit, Size, others), the order choices
     cascade in; ord[i] = option i's values in display order; auto[i] = the card chose it because it was the only value
     left (the server marks those data-wl-auto), so it is cleared again when an earlier choice offers more than one.
     T6.32e review fixes: pick[i] = the value the shopper (or Set for all) last chose on select i, -1 for none. update()
     puts it back once the earlier choices make it again. ci = the Colour option index (-1 without a Colour select);
     cx = over 250 variants only, the colours whose rows are all in the data (whole()). note = what the last update()
     did to the selects after the first, for the status line. */
  function rowOk(v, j, n) {
    if (!Array.isArray(v) || v.length !== n + 4 || !(v[0] > 0)) return false;
    for (var i = 0; i < n; i++) if (!(v[i + 1] >= 0 && v[i + 1] < j.o[i].length && v[i + 1] % 1 === 0)) return false;
    return true;
  }
  function state(card) {
    if (card._wl !== undefined) return card._wl;
    var s = card.querySelector('script[data-wl-v]'), j = null, st = null, n;
    try { j = JSON.parse(s.textContent); } catch (e) { j = null; }
    if (j && Array.isArray(j.o) && Array.isArray(j.v) && Array.isArray(j.p) && j.o.length && j.v.length &&
        j.o.every(Array.isArray) && j.v.every(function (v) { return rowOk(v, j, j.o.length); })) {
      n = j.o.length;
      st = { j: j, n: n, els: [], sel: [], auto: [], ord: [], chain: [], pick: [], ci: -1, cx: null, note: [], vid: 0, busy: false, done: false, html: null, shot: null };
      j.o.forEach(function (vals, i) {
        st.els[i] = null;
        st.sel[i] = Array.isArray(vals) && vals.length === 1 ? 0 : -1;
        st.pick[i] = -1;
      });
      each(card.querySelectorAll('select[data-wl-o]'), function (el) {
        var i = +el.getAttribute('data-wl-o'), u = el.hasAttribute('data-wl-u'), x = parseInt(el.value, 10);
        if (!(i >= 0 && i < n) || st.els[i]) return;
        st.els[i] = el;
        st.chain.push(i);
        st.auto[i] = el.hasAttribute('data-wl-auto') && !u;
        st.ord[i] = order(j.o[i], el.getAttribute('data-wl-k'));
        if (u && x >= 0 && x < j.o[i].length) st.pick[i] = x; /* changed before this script started: theirs */
        if (st.ci < 0 && el.getAttribute('data-wl-k') === 'colour') st.ci = i;
      });
      if (j.x) st.cx = whole(j, st.ci);
      st.shot = shots(card, j); /* T6.32f: null when this card carries no photo data */
    }
    card._wl = st;
    return st;
  }
  /* T6.32e: an option's value indexes in display order: product order, or XXS to 7XL for a Size whose values are all
     letter sizes (the order the server printed them in, which the server may have cut down to one colour). */
  function order(vals, key) {
    var idx = vals.map(function (v, k) { return k; });
    if (key !== 'size' || !vals.every(function (v) { return SIZE_ORDER.indexOf(v) > -1; })) return idx;
    return idx.sort(function (a, b) { return SIZE_ORDER.indexOf(vals[a]) - SIZE_ORDER.indexOf(vals[b]); });
  }
  /* T6.32e review fixes: over 250 variants the data holds the first 250 rows only. The store's big products list their
     variants colour by colour (checked on all four live ones: lobbyland, space-kangaroo, do-what-i-want-ibis-life,
     thou-shalt-not-steal-charity), so every colour that shows up before the last row's colour has all its rows here.
     Returns those colours as { value index: 1 }. The last row's colour may be cut short and later colours are missing
     altogether, so they are left out. Rows that do not run colour by colour (a colour coming back after another one),
     or no Colour select: none, and the whole card stays loose as before. A variant added out of order later on can
     only make a colour offer less than it has, never something that is not made. */
  function whole(j, ci) {
    var seen = {}, cx = {}, prev = -1, r, c, last;
    if (ci < 0) return cx;
    for (r = 0; r < j.v.length; r++) {
      c = j.v[r][ci + 1];
      if (c === prev) continue;
      if (seen[c]) return {};
      seen[c] = 1;
      prev = c;
    }
    last = j.v[j.v.length - 1][ci + 1];
    Object.keys(seen).forEach(function (k) { if (+k !== last) cx[k] = 1; });
    return cx;
  }
  function fits(v, sel, skip) {
    for (var i = 0; i < sel.length; i++) if (i !== skip && sel[i] > -1 && v[i + 1] !== sel[i]) return false;
    return true;
  }
  /* T6.32e: sets a select's list (after its placeholder) to the values in has, in display order: "(sold out)" and
     disabled when none of those variants is available. loose(k) true = value k's rows may be missing (over 250
     variants): listed anyway and never disabled (ALL: every value, as before). Only touches the DOM when the list differs. */
  function paint(el, ord, base, has, ok, loose) {
    var want = [], now = [], i, o;
    ord.forEach(function (k) {
      var u = !!(loose && loose(k));
      if (typeof base[k] !== 'string' || (!u && !has[k])) return;
      want.push({ k: String(k), t: base[k] + (has[k] && !ok[k] ? ' (sold out)' : ''), d: !u && !ok[k] });
    });
    for (i = 1; i < el.options.length; i++) now.push(el.options[i].value + (el.options[i].disabled ? '!' : ':') + el.options[i].textContent);
    if (want.map(function (w) { return w.k + (w.d ? '!' : ':') + w.t; }).join('\n') === now.join('\n')) return;
    while (el.options.length > 1) el.remove(1);
    want.forEach(function (w) {
      o = d.createElement('option');
      o.value = w.k;
      o.textContent = w.t;
      o.disabled = w.d;
      el.appendChild(o);
    });
  }
  /* Same price markup as snippets/product-card.liquid. Prices are the card's own Liquid money strings. */
  function setPrice(card, st, v) {
    var box = card.querySelector('[data-wl-price]'), p = st.j.p[v[st.n + 2]], c = v[st.n + 3] > -1 ? st.j.p[v[st.n + 3]] : null, html;
    if (!box || typeof p !== 'string') return;
    html = typeof c === 'string' ? '<del class="product-tile__compare-price">' + c + '</del> <span class="">' + p + '</span>' : p;
    if (html !== st.html) { st.html = html; box.innerHTML = html; }
  }
  /* ---- T6.32f (20 Sep 2026) the card photo follows the choice ----
     The card JSON carries j.i = { media position: image path }, j.m[row] = the media position of that variant
     (0 = it has no photo of its own) and j.b = the position of the photo the card rendered, which is also the
     fallback. The paths have the CDN prefix cut off them, so cdn() reads it back off the card's own <img> src:
     everything before the last two path segments, which is how the snippet cut it (Shopify serves every image as
     <prefix>/files/<name> or <prefix>/products/<name>). Neither side knows the shop's CDN host.
     shots() returns null when the card carries no photo data (no variant photos, over 250 variants, or a src the
     prefix cannot be read from), and then nothing below runs: the card keeps the photo it was rendered with. */
  var IMG_W = 640; /* the card photo is about 170px to 320px wide, so this is roughly 2x the widest */
  function cdn(src) {
    var p, tail, at;
    if (!src || src.slice(0, 5) === 'data:') return null;
    p = src.split('?')[0].split('/');
    if (p.length < 2) return null;
    tail = p[p.length - 2] + '/' + p[p.length - 1];
    at = src.lastIndexOf(tail);
    return at < 0 ? null : src.slice(0, at);
  }
  function shots(card, j) {
    var img = card.querySelector('.lkc-wl-card__img img'), base, sh;
    if (!img || !j.i || typeof j.i !== 'object' || !Array.isArray(j.m) || j.m.length !== j.v.length ||
        !(j.b > 0) || typeof j.i[j.b] !== 'string') return null;
    base = cdn(img.getAttribute('src'));
    if (base === null) return null;
    sh = { img: img, base: base, alt: img.getAttribute('alt') || '', src0: img.getAttribute('src'), set0: img.getAttribute('srcset'), size0: img.getAttribute('sizes'), now: j.b, want: j.b, at: -1, tok: 0, t: 0, opts: null };
    /* T6.32f review fix: the off-screen path below puts a photo in without waiting for it, so if that one cannot
       be fetched the card would sit on a broken image. This puts back the photo the card was rendered with. */
    img.addEventListener('error', function () {
      if (sh.now === j.b) return; /* the card's own photo failed: nothing of ours to put back */
      sh.now = sh.want = j.b;
      sh.at = -1;
      sh.img.setAttribute('src', sh.src0 || '');
      if (sh.set0) sh.img.setAttribute('srcset', sh.set0);
      if (sh.size0) sh.img.setAttribute('sizes', sh.size0);
      if (sh.img.getAttribute('alt') !== sh.alt) sh.img.setAttribute('alt', sh.alt);
    });
    return sh;
  }
  /* The options that change the photo, read off the data rather than assumed: option i counts when two variants
     that differ only in i have different photos. On this store that comes out as colour and fit and never size,
     but a product that works another way reads the same. Only the alt text uses it. */
  function shotOpts(st) {
    var j = st.j, n = st.n, out = [], i, r, k, key, seen;
    for (i = 0; i < n; i++) {
      seen = {};
      for (r = 0; r < j.v.length; r++) {
        key = '';
        for (k = 0; k < n; k++) if (k !== i) key += j.v[r][k + 1] + '.';
        if (seen[key] === undefined) seen[key] = j.m[r];
        else if (seen[key] !== j.m[r]) { out.push(i); break; }
      }
    }
    return out;
  }
  /* "Bread Tee | Lonely Kids Club Australia" becomes "Bread Tee, Ecru Maple | Lonely Kids Club Australia" (the
     card's alt comes from snippets/image-collection-thumb.liquid, T5.33). The product photo keeps the card's own alt. */
  function shotAlt(st, pos, at) {
    var sh = st.shot, vals = [];
    if (pos === st.j.b || at < 0) return sh.alt;
    if (!sh.opts) sh.opts = shotOpts(st);
    sh.opts.forEach(function (i) {
      var v = st.j.o[i][st.j.v[at][i + 1]];
      if (typeof v === 'string' && v) vals.push(v);
    });
    if (!vals.length) return sh.alt;
    return sh.alt.indexOf(' | ') > 0 ? sh.alt.replace(' | ', ', ' + vals.join(' ') + ' | ') : sh.alt + ', ' + vals.join(' ');
  }
  /* at = the variant row the card is showing (-1 for none: back to the product photo). A photo is only asked for
     when a choice lands on a different one, never to have it ready, and the load is left to the next task so one
     burst of changes (set for all puts a card back and then sets it again in the same step) asks for one photo. */
  function showShot(card, st, at) {
    var sh = st.shot, pos;
    if (!sh) return;
    pos = at > -1 && st.j.m[at] ? st.j.m[at] : st.j.b;
    if (pos === sh.want) return;
    sh.want = pos;
    sh.at = at;
    if (!sh.t) sh.t = setTimeout(function () { sh.t = 0; loadShot(st); }, 0);
  }
  /* Putting a photo in never moves anything: the <img> keeps its place, its square box and its lazy loading, and
     only src, srcset, sizes and alt change. srcset and sizes are dropped first, otherwise the browser is free to
     keep picking a candidate of the old photo. */
  function putShot(sh, pos, url, alt) {
    sh.now = pos;
    sh.img.removeAttribute('srcset');
    sh.img.removeAttribute('sizes');
    sh.img.setAttribute('src', url);
    if (sh.img.getAttribute('alt') !== alt) sh.img.setAttribute('alt', alt);
  }
  /* T6.32f review fix: an <img> that is still loading="lazy" and is nowhere near the viewport is left to the
     browser. Nothing is visible there, so there is no flash to guard against, and a lazy <img> holds its own
     fetch back until it is scrolled to. Without this, a shopper who has ever used "set colour for all" has a
     remembered colour put on every card the first time it is seen, which is page load, and new Image() (which
     ignores lazy loading) asks the CDN for a photo for every card in the list before they have touched anything. */
  var LAZY_M = 200;
  function far(img) {
    var r = img.getBoundingClientRect(), h = window.innerHeight || 0;
    if (!r.width && !r.height) return true; /* not laid out, or in something hidden */
    return r.bottom < -LAZY_M || r.top > h + LAZY_M;
  }
  /* In view, the photo only goes in once it has loaded, so the box never empties and there is no flash. */
  function loadShot(st) {
    var sh = st.shot, j = st.j, pos = sh.want, path = j.i[pos], url, alt, tok = ++sh.tok, pre;
    if (pos === sh.now) return;
    if (typeof path !== 'string' || !path) { sh.want = sh.now; return; }
    url = sh.base + path + (path.indexOf('?') > -1 ? '&' : '?') + 'width=' + IMG_W;
    alt = shotAlt(st, pos, sh.at);
    if (sh.img.getAttribute('loading') === 'lazy' && far(sh.img)) { putShot(sh, pos, url, alt); return; }
    pre = new Image();
    pre.onload = function () {
      if (tok !== sh.tok) return; /* they have chosen something else since: that photo wins */
      putShot(sh, pos, url, alt);
    };
    pre.onerror = function () { if (tok === sh.tok) sh.want = sh.now; }; /* photo gone: keep the one on screen */
    pre.src = url;
  }
  /* mode: add | choose (looks disabled, still focusable) | off (disabled) | busy | done | link (opens the product)
     T6.32e: busy also carries the theme's js-loading class, so the button shows the product page loading state
     (component-base.css .button.add-to-cart.js-loading: transparent, black text, the sloth rainbow). */
  function setBtn(btn, text, mode) {
    var label = btn.querySelector('[data-wl-add-text]') || btn;
    if (label.textContent !== text) label.textContent = text;
    btn.disabled = mode === 'off';
    if (mode === 'choose' || mode === 'busy') btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
    btn.setAttribute('data-wl-state', mode);
    if (btn.classList) btn.classList.toggle('js-loading', mode === 'busy');
  }
  /* Reads the selects and brings the lists, price and button in line with them. Returns the state.
     T6.32e cascade, in chain order (Colour, Fit, Size, others): each select lists only the values made with the
     choices before it (Fit: in the chosen colour; Size: in the chosen colour and fit, or any fit while Fit is open),
     sold-out ones disabled. A choice that is not made or is sold out with the ones before it goes back to the
     placeholder, and so does one the card picked itself once there is more than one value again. After Colour, a
     select with a single value left (in stock) is picked for the shopper and stays visible, so they see which fit
     they are getting. Nothing in stock at all: choices are kept, every entry is marked sold out, the button says Sold out.
     Over 250 variants (j.x) nothing is filtered or cleared, as before (the rows past 250 are not in the data).
     T6.32e review fixes: over 250 variants, a Colour whose rows are all here (st.cx) cascades like any card; only the
     colour the data stops in, the colours after it, or no Colour chosen stay loose as before. The Colour list itself lists
     every colour and marks sold out only complete ones. A later select left empty (cleared, or never chosen) gets the
     shopper's own pick back once it is made and in stock with the earlier choices. force = select values in chain
     order to use instead of the selects' own (put() and the Set for all run use it: a value the list does not hold
     yet cannot be set on a select before it is repainted). st.note records what changed after the first select. */
  function update(card, force) {
    var st = state(card), btn = card.querySelector('button[data-wl-add]'), j, n, sel, cur, any, full = true, match = null, open = null, exact = null, next = -1, matchAt = -1, openAt = -1;
    if (!st) {
      if (btn) setBtn(btn, 'View product', 'link'); /* unreadable data: the product page can still sell it */
      return null;
    }
    j = st.j; n = st.n; sel = st.sel; st.note = [];
    st.chain.forEach(function (i, at) {
      var raw = force ? force[at] : st.els[i].value, x = raw === '' || raw == null ? -1 : parseInt(raw, 10);
      sel[i] = x >= 0 && x < j.o[i].length ? x : -1;
    });
    any = j.v.some(function (v) { return v[n + 1]; });
    cur = sel.map(function (x, i) { return st.els[i] ? -1 : x; }); /* options without a select are fixed */
    st.chain.forEach(function (i, at) {
      var has = {}, ok = {}, vals = [], want = sel[i], was = want, auto0 = !!st.auto[i], el = st.els[i], pk = st.pick[i], lo = null;
      j.v.forEach(function (v) {
        var k = v[i + 1];
        if (!fits(v, cur, i)) return;
        if (!has[k]) { has[k] = 1; vals.push(k); }
        if (v[n + 1]) ok[k] = 1;
      });
      if (j.x) {
        if (i === st.ci) lo = function (k) { return !st.cx[k]; };
        else if (!(st.ci > -1 && cur[st.ci] > -1 && st.cx[cur[st.ci]])) lo = ALL;
      }
      if (lo !== ALL) {
        if (want > -1 && !(lo && lo(want)) && !(any ? ok[want] : has[want])) want = -1;
        if (want > -1 && st.auto[i] && vals.length > 1) want = -1;
        if (want < 0) st.auto[i] = false;
        if (want < 0 && pk > -1 && ok[pk]) want = pk; /* theirs again, now it is made */
        if (want < 0 && any && at > 0 && vals.length === 1 && ok[vals[0]]) { want = vals[0]; st.auto[i] = true; }
      }
      cur[i] = want;
      paint(el, st.ord[i], j.o[i], has, ok, lo);
      if (el.value !== (want > -1 ? String(want) : '')) el.value = want > -1 ? String(want) : '';
      if (at > 0 && want !== was) st.note.push({ i: i, was: was, now: want, auto: !!st.auto[i], wasAuto: auto0, sold: was > -1 && !!has[was] && !ok[was] });
    });
    cur.forEach(function (x, i) { sel[i] = x; if (x < 0) full = false; });
    st.chain.forEach(function (i) { if (next < 0 && sel[i] < 0) next = i; });
    j.v.forEach(function (v, r) {
      if (!fits(v, sel, -1)) return;
      if (!match) { match = v; matchAt = r; }
      if (!open && v[n + 1]) { open = v; openAt = r; }
    });
    if (full) exact = match;
    if (exact || open || match) setPrice(card, st, exact || open || match);
    /* T6.32f: the photo follows the same row the price does, so a colour on its own already changes it */
    showShot(card, st, exact ? matchAt : open ? openAt : matchAt);
    if (!btn || st.busy || st.done) return st;
    st.vid = 0;
    if (full && exact && exact[n + 1]) {
      st.vid = exact[0];
      setBtn(btn, 'Add to cart', 'add');
    } else if (full && exact) setBtn(btn, 'Sold out', 'off');
    else if (full) setBtn(btn, j.x ? 'View product' : 'Not available', j.x ? 'link' : 'off');
    else if (match && !open && !j.x) setBtn(btn, 'Sold out', 'off');
    else if (!match && !j.x) setBtn(btn, 'Not available', 'off');
    else if (next > -1) setBtn(btn, 'Choose ' + norm(st.els[next].options[0] ? st.els[next].options[0].text : ''), 'choose'); /* the next one only */
    else setBtn(btn, 'View product', 'link');
    return st;
  }
  /* The error line stays until the shopper changes something on that card or adds again: hiding it on a timer
     would move every row below with nobody touching the page. */
  function hideErr(card) {
    var el = card.querySelector('[data-wl-err]');
    if (el && !el.hidden) { el.hidden = true; el.textContent = ''; }
  }
  function showErr(card, msg) {
    var el = card.querySelector('[data-wl-err]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }
  /* Hidden status line per root (cardEvents adds it): a successful add is read out, since the button text changing
     under focus often is not. Cleared first so the same message twice is read twice. */
  function say(card, msg) {
    var root = card.closest('[data-lkc-wl-page]'), live = root && root.querySelector('[data-wl-live]');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }
  /* T6.32e review fixes: what the shopper's change on select i did to the later selects (st.note), in plain words for
     the status line, e.g. "Crop Top isn't made in Mauve. Choose fit." or "Pink only comes in Regular Hoodie, so that's
     chosen." Focus stays on the select they changed, so without this a screen reader user would not hear that a fit or
     size went. The earlier choices are named in card order ("in Sage Crop Top"). Empty when nothing else changed. */
  function tell(card, st, i) {
    var j = st.j, at = st.chain.indexOf(i), ctx = [], gone = [], sold = [], rest = [], out = [], b = card.querySelector('button[data-wl-add]'), t;
    if (!st.note.length) return '';
    st.chain.slice(0, at + 1).forEach(function (m) { if (st.sel[m] > -1) ctx.push(j.o[m][st.sel[m]]); });
    ctx = ctx.join(' ');
    function and(list) { return list.length > 1 ? list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1] : list[0]; }
    st.note.forEach(function (x) {
      var name = norm(st.els[x.i].options[0] ? st.els[x.i].options[0].text : '');
      if (x.now > -1) rest.push(x.auto && ctx ? ctx + ' only comes in ' + j.o[x.i][x.now] + ', so that\'s chosen.' : j.o[x.i][x.now] + ' is chosen again.');
      else if (x.wasAuto) { if (ctx && name) rest.push(ctx + ' comes in more than one ' + name + '.'); }
      else (x.sold ? sold : gone).push(j.o[x.i][x.was]);
    });
    if (ctx && gone.length) out.push(and(gone) + (gone.length > 1 ? ' aren\'t' : ' isn\'t') + ' made in ' + ctx + '.');
    if (ctx && sold.length) out.push(and(sold) + (sold.length > 1 ? ' are' : ' is') + ' sold out in ' + ctx + '.');
    out = out.concat(rest);
    if (b && b.getAttribute('data-wl-state') === 'choose' && (t = b.querySelector('[data-wl-add-text]'))) out.push(t.textContent + '.');
    return out.join(' ');
  }
  /* The DOM updates QuickView.addtocart makes after a successful add: count label + bubble, drawer form. */
  function swapDrawer(data) {
    var count = d.getElementById('cart-drawer-item-count'), label = count && count.querySelector('.count-label');
    var bubble = d.getElementById('cart-count-bubble'), form = d.getElementById('form-cart-drawer');
    var html = data && data.sections && data.sections['cart-drawer'], doc, newForm, newCount;
    if (data && typeof data.item_count === 'number') {
      if (label) label.textContent = data.item_count;
      if (bubble) bubble.textContent = data.item_count;
    }
    if (typeof html !== 'string') return;
    doc = new DOMParser().parseFromString(html, 'text/html');
    newForm = doc.getElementById('form-cart-drawer');
    newCount = doc.getElementById('cart-drawer-item-count');
    if (newCount) {
      if (label) label.textContent = newCount.textContent;
      if (bubble) bubble.textContent = newCount.textContent;
    }
    if (newForm && form) form.innerHTML = newForm.innerHTML;
  }
  function call(name, method) {
    try {
      var o = window.theme && window.theme[name];
      if (o && typeof o[method] === 'function') o[method]();
    } catch (e) { /* ignore */ }
  }
  /* Adds from different cards run one after another (the quick-add modal can only ever run one): cartQ is the chain,
     cartN the adds queued or running. Checkout stays locked until cartN is back to 0, and each drawer swap comes from
     the latest cart. */
  var cartQ = null, cartN = 0;
  function addToCart(card, btn, st) {
    var vid = st.vid, item = card.closest('[data-wl-item]'), body = new FormData(), added = false, ended = false, release = null;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var checkout = d.querySelector('#cart-drawer > .cart-footer > #checkout');
    var FAIL = 'Could not add to cart. Check your connection and try again.';
    if (!vid || st.busy) return;
    st.busy = true;
    hideErr(card);
    setBtn(btn, 'Adding...', 'busy');
    cartN++;
    if (checkout) checkout.disabled = true;
    body.append('id', vid);
    body.append('quantity', '1');
    body.append('sections', 'cart-drawer');
    /* Same order as the quick-add modal's finally: open the drawer (only after an add), then the progress bar,
       cart upsell row and quick view rebind, then unlock checkout (once no other add is waiting). A refused add
       (e.g. not enough stock) shows Shopify's message under the button instead and leaves the drawer closed. */
    function finish(msg) {
      var drawer, overlay, modal, name;
      if (ended) return;
      ended = true;
      st.busy = false;
      cartN--;
      try {
        if (added) {
          drawer = d.getElementById('cart-drawer');
          overlay = d.getElementById('cart-drawer-overlay');
          modal = d.getElementById('quick-view-modal');
          if (drawer) drawer.classList.add('active');
          if (overlay) overlay.classList.add('active');
          if (modal) modal.classList.remove('active');
        }
        call('PromotionalProgressbar', 'recalculate');
        call('CartDrawerUpsell', 'load');
        call('QuickView', 'load');
        if (checkout && !cartN) checkout.disabled = false;
        if (!added) {
          update(card);
          showErr(card, msg);
          return;
        }
        st.done = true;
        setBtn(btn, 'Added', 'done');
        name = card.querySelector('.spf-product-card__title a');
        say(card, 'Added ' + (name ? name.textContent.trim() + ' ' : '') + 'to cart');
        setTimeout(function () { st.done = false; update(card); }, ADDED_MS);
        /* Next task, like the heart and share events: the lazy GTM loader creates dataLayer when the click reaches window. */
        setTimeout(function () {
          if (window.dataLayer && typeof window.dataLayer.push === 'function') {
            window.dataLayer.push({ event: 'lkc_wishlist', action: 'add_to_cart', product_id: item ? +item.getAttribute('data-wl-item') : 0, variant_id: vid });
          }
        }, 0);
      } finally {
        if (release) release();
      }
    }
    function send() {
      try {
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: body })
          .then(function (r) {
            if (!r.ok) {
              return r.json().catch(function () { return null; }).then(function (e) {
                var m = e && (typeof e.description === 'string' && e.description ? e.description : e.message);
                finish(typeof m === 'string' && m ? m : 'Sorry, this item is unavailable. Please try again or pick a different option.');
              });
            }
            added = true;
            return r.json().then(swapDrawer).catch(function (e) {
              if (window.console) console.error(e);
            }).then(function () { finish(''); });
          })
          .catch(function () { finish(FAIL); });
      } catch (e) { finish(FAIL); }
    }
    function turn() { return new Promise(function (res) { release = res; send(); }); }
    /* Nothing else waiting: send now, as before. Otherwise after the add in front has finished. */
    cartQ = cartN > 1 && cartQ ? cartQ.then(turn) : turn();
  }
  function firstEmpty(card) {
    var hit = null;
    each(card.querySelectorAll('select[data-wl-o]'), function (el) { if (!hit && el.value === '') hit = el; });
    return hit;
  }
  /* Card selects and Add to cart buttons inside one root (own list, shared view or account block). */
  function cardEvents(root) {
    var live = d.createElement('p');
    live.className = 'sr-only';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('data-wl-live', '');
    root.appendChild(live);
    function cardOf(t) { return t && t.closest ? t.closest('[data-wl-card]') : null; }
    /* Value marks are worked out the first time a card's select is reached, before its list opens.
       T6.32e: set-for-all's refresh() now brings every card in line as it is shown; this stays as a backstop. */
    function prime(e) {
      var t = e.target, c = t && t.closest && t.closest('select[data-wl-o]') ? cardOf(t) : null;
      if (c && !c._wlSeen) { c._wlSeen = true; update(c); }
    }
    root.addEventListener('focusin', prime);
    root.addEventListener('pointerdown', prime, { passive: true });
    root.addEventListener('change', function (e) {
      var t = e.target, c, st, i, x, msg;
      if (!t || !t.matches || !t.matches('select[data-wl-o]') || !(c = cardOf(t))) return;
      t.setAttribute('data-wl-u', ''); /* the shopper's own choice: remembered set-for-all values leave it alone */
      i = +t.getAttribute('data-wl-o');
      if ((st = state(c))) {
        st.auto[i] = false; /* T6.32e: theirs now, kept while it is made */
        x = t.value === '' ? -1 : parseInt(t.value, 10);
        st.pick[i] = x >= 0 ? x : -1; /* review fixes: remembered until they change this select again */
      }
      c._wlSeen = true;
      hideErr(c);
      update(c);
      if (st && (msg = tell(c, st, i))) say(c, msg);
    });
    root.addEventListener('click', function (e) {
      var t = e.target, b = t && t.closest ? t.closest('button[data-wl-add]') : null, c = cardOf(b), st, mode, x;
      if (!c) return;
      e.preventDefault();
      c._wlSeen = true;
      st = update(c); /* null (unreadable data) leaves the button on View product */
      mode = b.getAttribute('data-wl-state');
      if (mode === 'choose') {
        if ((x = firstEmpty(c))) x.focus();
      } else if (mode === 'link') {
        if ((x = c.querySelector('a[href]'))) location.href = x.href;
      } else if (mode === 'add' && st) {
        addToCart(c, b, st);
      }
    });
  }

  /* ---- T6.31c (17 Sep 2026) set size, colour or fit for all ---- */
  var prefMem = null, prefMemOnly = false;
  function prefs() {
    var raw = prefMem, j = null, p = {};
    if (!prefMemOnly) { try { raw = localStorage.getItem(PREF); } catch (e) { raw = prefMem; } }
    try { j = JSON.parse(raw || '{}'); } catch (e) { j = null; }
    if (j && typeof j === 'object') {
      KEYS.forEach(function (k) { if (typeof j[k] === 'string' && j[k].trim() && j[k].length <= 100) p[k] = j[k]; });
    }
    return p;
  }
  function storePrefs(p) {
    prefMem = JSON.stringify(p);
    try {
      if (Object.keys(p).length) localStorage.setItem(PREF, prefMem);
      else localStorage.removeItem(PREF);
    } catch (e) { prefMemOnly = true; /* private mode or full: this visit only */ }
  }
  /* Natural size order: baby and kids sizes (months, 000, 00, 0, ages and numbers) ascending, then XXS to 7XL, then
     anything else A to Z. */
  function sizeKey(v) {
    var s = String(v).trim().toUpperCase(), i = SIZES.indexOf(SIZE_ALIAS[s] || s), m;
    if (i > -1) return [1, i];
    if (/^0+$/.test(s)) return [0, 1 - s.length];
    m = s.match(/\d+(\.\d+)?/);
    if (m) return [0, /\d\s*M(THS?|ONTHS?)?\b/.test(s) ? parseFloat(m[0]) / 12 - 3 : parseFloat(m[0])];
    return [2, 0];
  }
  function byName(a, b) { return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' }); }
  function bySize(a, b) {
    var x = sizeKey(a), y = sizeKey(b);
    return x[0] - y[0] || x[1] - y[1] || byName(a, b);
  }
  /* ---- T6.32e (19 Sep 2026) what set for all needs from a card ----
     keySel = the card's select for colour / fit / size (none when the card has no choice there: no such option, or a
     single value). A panel choice only narrows cards that have that choice, so a kids tee with its one fit still
     offers its sizes after Fit is chosen. */
  function keySel(card, key) { return card.querySelector('select[data-wl-k="' + key + '"]'); }
  function hasKeys(card) { return KEYS.some(function (k) { return !!keySel(card, k); }); }
  function valueAt(st, i, value) {
    var vals = st.j.o[i], k;
    for (k = 0; k < vals.length; k++) if (norm(vals[k]) === norm(value)) return k;
    return -1;
  }
  /* T6.32e review fixes: the values the card would take for key, as { value index: 1 }, the same way a shopper changes
     that select on the card: a value only has to be made and in stock with the card's choices BEFORE it (nothing before
     Colour; Colour before Fit; Colour and Fit before Size), and update() then clears the later choices it does not make.
     So a colour is never blocked by the card's fit or size. Over 250 variants, when the resulting colour is not one of
     the complete ones (st.cx) the card stays loose and nothing would be cleared, so there the whole resulting choice (every
     current value, the new one swapped in) must match a listed variant in stock: never something not made.
     Returns { el, st, i, set } or null (no select for key, or no readable data). */
  function takeable(card, key) {
    var el = keySel(card, key), st = el ? state(card) : null, i, at, early, set = {};
    if (!st) return null;
    i = +el.getAttribute('data-wl-o');
    if (st.els[i] !== el) return null;
    at = st.chain.indexOf(i);
    early = st.sel.map(function (x, m) { return st.els[m] && st.chain.indexOf(m) > at ? -1 : x; });
    st.j.v.forEach(function (v) {
      var k = v[i + 1], c;
      if (set[k] || !v[st.n + 1]) return;
      c = st.ci < 0 ? -1 : st.ci === i ? k : st.sel[st.ci];
      if (fits(v, !st.j.x || (c > -1 && st.cx[c]) ? early : st.sel, i)) set[k] = 1;
    });
    return { el: el, st: st, i: i, set: set };
  }
  /* Would the card take value (any letter case) for key? Returns { el, st, i, k } or null. */
  function takes(card, key, value) {
    var t = takeable(card, key), k;
    if (!t || (k = valueAt(t.st, t.i, value)) < 0 || !t.set[k]) return null;
    return { el: t.el, st: t.st, i: t.i, k: k };
  }
  /* Sets it as the shopper would (their pick from now on), then brings the card in line. */
  function put(card, hit) {
    var st = hit.st;
    st.auto[hit.i] = false;
    st.pick[hit.i] = hit.k;
    update(card, st.chain.map(function (m) { return m === hit.i ? String(hit.k) : st.els[m].value; }));
  }
  /* A card's select values, auto marks and picks, and putting them back (the Set for all run, first()). */
  function snap(st) { return { v: st.chain.map(function (i) { return st.els[i].value; }), a: st.auto.slice(), p: st.pick.slice() }; }
  function same(st, s) {
    return st.chain.every(function (i, x) { return st.els[i].value === s.v[x] && !!st.auto[i] === !!s.a[i] && st.pick[i] === s.p[i]; });
  }
  function back(card, st, s) {
    st.auto = s.a.slice();
    st.pick = s.p.slice();
    update(card, s.v);
  }
  /* One per root. grid = the grid whose cards it works on (data-wl-grid, or data-wl-sgrid in the shared view).
     refresh() runs after every grid change: cards seen for the first time are brought in line and get remembered
     values, and the row shows while 2 or more cards (or placeholders still loading) have a Colour, Fit or Size select. */
  function setAll(root, grid) {
    var box = root.querySelector('[data-wl-setall]'), btn = box && box.querySelector('[data-wl-setall-btn]');
    var panel = box && box.querySelector('[data-wl-setall-panel]'), open = false;
    function cards() { return grid ? grid.querySelectorAll('[data-wl-card]') : []; }
    /* A card seen for the first time. A select that already differs from its server default was changed by the
       shopper before this script started (slow phone) or restored by the browser, so it is marked as their own choice
       first and remembered values leave it alone. T6.32e: then the card is brought in line straight away (lists cut
       to what is made, the button asking for the next choice), and remembered values go on in Colour, Fit, Size order
       wherever the card takes them. */
    function first(card, p) {
      card._wlAuto = true;
      each(card.querySelectorAll('select[data-wl-o]'), function (el) {
        var i, def = 0;
        for (i = 0; i < el.options.length; i++) if (el.options[i].defaultSelected) def = i;
        if (el.selectedIndex !== def) el.setAttribute('data-wl-u', '');
      });
      card._wlSeen = true;
      update(card);
      KEYS.forEach(function (k) {
        var hit = p[k] ? takes(card, k, p[k]) : null, keep;
        if (!hit || hit.el.hasAttribute('data-wl-u')) return;
        keep = snap(hit.st);
        put(card, hit);
        /* T6.32e review fixes: a remembered value never undoes a later select the shopper already changed */
        if (hit.st.chain.some(function (i, x) { return hit.st.els[i].hasAttribute('data-wl-u') && hit.st.els[i].value !== keep.v[x]; })) back(card, hit.st, keep);
      });
    }
    /* T6.32e panel lists. Review fixes: each list is what the shown cards would take right now (takeable(): made and in
       stock with each card's own choices before that key), so a list and its counts always agree and no colour is
       blocked by a fit or size. count = how many cards it would go on; total = the cards that have that choice (a
       product made in one colour has no Colour select and is not counted as "not coming in" Black). */
    function offer() {
      var out = {};
      KEYS.forEach(function (k) {
        var r = { vals: [], disp: {}, count: {}, total: 0 };
        each(cards(), function (card) {
          var t = takeable(card, k), seen = {};
          if (!t) return;
          r.total++;
          t.st.j.o[t.i].forEach(function (v, vk) {
            var nv = norm(v);
            if (!t.set[vk] || typeof v !== 'string' || seen[nv]) return;
            seen[nv] = 1;
            if (r.disp[nv] === undefined) { r.disp[nv] = v; r.vals.push(v); r.count[nv] = 0; }
            r.count[nv]++;
          });
        });
        r.vals.sort(k === 'size' ? bySize : byName);
        out[k] = r;
      });
      return out;
    }
    function fill(o) {
      var p = prefs();
      o = o || offer();
      KEYS.forEach(function (k) {
        var sel = panel.querySelector('select[data-wl-pref="' + k + '"]'), r = o[k], want, now, cur, field;
        if (!sel) return;
        want = [{ v: '', t: 'Any', d: false }].concat(r.vals.map(function (v) {
          var c = r.count[norm(v)];
          return { v: v, t: v + ' (' + c + ' of ' + r.total + ')', d: !c };
        }));
        now = Array.prototype.map.call(sel.options, function (x) { return x.value + (x.disabled ? '!' : ':') + x.textContent; }).join('\n');
        if (want.map(function (w) { return w.v + (w.d ? '!' : ':') + w.t; }).join('\n') !== now) {
          while (sel.options.length) sel.remove(0);
          want.forEach(function (w) {
            var x = d.createElement('option');
            x.value = w.v;
            x.textContent = w.t;
            x.disabled = w.d;
            sel.appendChild(x);
          });
        }
        cur = p[k] && r.disp[norm(p[k])] !== undefined ? r.disp[norm(p[k])] : '';
        if (sel.value !== cur) sel.value = cur;
        field = sel.closest('.lkc-wl-setall__field');
        if (field) field.hidden = !r.vals.length;
      });
    }
    function refresh() {
      var p = prefs(), withOpts = 0, hide, t;
      each(cards(), function (card) {
        if (!card._wlAuto) first(card, p);
        if (hasKeys(card)) withOpts++;
      });
      if (!box) return;
      hide = !grid || grid.hidden || withOpts + grid.querySelectorAll('.lkc-wl-skel').length < 2;
      if (hide && !box.hidden && box.contains(d.activeElement)) {
        t = root.querySelector('.lkc-wl-title');
        try { if (t) t.focus(); } catch (e) { /* ignore */ }
      }
      box.hidden = hide;
      if (open && !hide) fill();
    }
    if (btn && panel) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open = !open;
        if (open) fill();
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      /* T6.32e: counts follow the cards, so a card changed by hand while the panel is open refreshes it. */
      root.addEventListener('change', function (e) {
        var t = e.target;
        if (open && t && t.matches && t.matches('select[data-wl-o]') && grid && grid.contains(t)) fill();
      });
      /* A run = panel changes to one select less than SETTLE_MS apart. Arrow keys on a closed select (Windows browsers,
         some screen readers) fire change at every step, so Any to M passes through every size in between. Each card
         keeps its value from before the run (card._wlWas for run id card._wlRun): every step first puts that value
         back, then sets the step's value where the card takes it, so only the value the shopper stops on sticks. The
         toast waits for the run to end (SETTLE_MS quiet, or focus leaving the select). The remembered values are
         worked out from the ones before the run at every step, so cards filled in meanwhile and the panel itself
         always read the current choice. T6.32e: a later panel choice the new one rules out (no shown card makes it
         with the new one) goes back to Any; the toast says how many of the cards with options took it.
         T6.32e review fixes: a card takes the value as if the shopper had changed that select (takeable()), so update()
         may clear its later choices; each step first puts the whole card back (every select, auto mark and pick, card._wlWas),
         and the remembered later panel values then go on the selects it left empty where they are made. A later value is
         only forgotten when a shown card offered it before this run and none does now (run.was), so a remembered kids
         size stays for kids cards shown later. Counts and the toast are out of the cards that have that choice. */
      var run = null, runs = 0;
      function endRun() {
        var r = run, other;
        if (!r) return;
        run = null;
        clearTimeout(r.t);
        if (!r.v) return;
        other = r.total - r.n;
        toast(!r.n ? 'None of these come in ' + r.v
          : other < 1 ? 'Set on ' + r.n + (r.n === 1 ? ' item' : ' items')
          : 'Set on ' + r.n + ' of ' + r.total + ' items. The other ' + (other === 1 ? 'one doesn\'t' : other + ' don\'t') + ' come in that.');
      }
      panel.addEventListener('change', function (e) {
        var sel = e.target, k = sel && sel.getAttribute ? sel.getAttribute('data-wl-pref') : null, v, p = {}, n = 0, o, later;
        if (KEYS.indexOf(k) < 0) return;
        v = sel.value;
        if (run && run.k !== k) endRun();
        if (!run) run = { k: k, id: ++runs, t: 0, p0: prefs(), was: offer() };
        Object.keys(run.p0).forEach(function (x) { p[x] = run.p0[x]; });
        if (v) p[k] = v;
        else delete p[k]; /* Any: later cards are not preset */
        later = KEYS.slice(KEYS.indexOf(k) + 1);
        each(cards(), function (card) {
          var el = keySel(card, k), st = el ? state(card) : null, hit;
          if (!st) return;
          if (card._wlRun !== run.id) { card._wlRun = run.id; card._wlWas = snap(st); }
          if (!same(st, card._wlWas)) { /* an earlier step of this run changed it */
            hideErr(card);
            back(card, st, card._wlWas);
          }
          hit = v ? takes(card, k, v) : null;
          if (!hit) return; /* Any, or not made (in stock) with the card's earlier choices: left as it was */
          n++;
          card._wlSeen = true;
          hideErr(card);
          put(card, hit);
          later.forEach(function (x) {
            var s2 = keySel(card, x), h2;
            if (p[x] && s2 && s2.value === '' && (h2 = takes(card, x, p[x]))) put(card, h2);
          });
        });
        o = offer();
        later.forEach(function (x) {
          var w = norm(p[x] || '');
          if (p[x] && run.was[x].disp[w] !== undefined && o[x].disp[w] === undefined) delete p[x];
        });
        storePrefs(p);
        fill(o);
        run.v = v;
        run.n = n;
        run.total = o[k].total;
        clearTimeout(run.t);
        run.t = setTimeout(endRun, SETTLE_MS);
      });
      panel.addEventListener('focusout', endRun);
    }
    return { refresh: refresh };
  }

  function setup(root, W, sa) {
    var grid = root.querySelector('[data-wl-grid]');
    if (!grid) return;
    var shown = +root.getAttribute('data-limit') || STEP, more = root.hasAttribute('data-more');
    var map = {}, server = {}, missing = {}, failed = {}, cards;
    var shareLabel = root.querySelector('[data-wl-share-label]'), shareText = shareLabel ? shareLabel.textContent : '', copyTimer = 0;
    try { map = JSON.parse(root.querySelector('[data-wl-handles]').textContent) || {}; } catch (e) { map = {}; }
    try { JSON.parse(d.getElementById('lkc-wl-acct').textContent).ids.forEach(function (id) { server[+id] = 1; }); } catch (e) { /* guest */ }

    function el(sel) { return root.querySelector(sel); }
    function show(node, on) { if (node) node.hidden = !on; }
    function handleOf(id) { return typeof map[id] === 'string' && map[id] ? map[id] : W.handleOf(id); }

    cards = loader(function (job, item) {
      var h;
      if (item && +item.getAttribute('data-wl-item') === job.id) {
        h = item.getAttribute('data-product-handle');
        if (h && h !== job.h) { map[job.id] = h; W.rememberHandle(job.id, h); }
        xify(item);
        if (job.n.parentNode) job.n.parentNode.replaceChild(item, job.n);
      } else {
        missing[job.id] = 1; /* unavailable, or the handle now belongs to another product */
      }
    }, function (job) { failed[job.id] = 1; }, sync);

    /* Keyboard focus: when the focused card goes, move to the same kind of control (the X, else a link) on the
       next card, else the previous one, else the heading, instead of dropping back to the top of the page. */
    function focusIn(node) {
      if (!node || node.parentNode !== grid) return null;
      return node.querySelector('button[data-wl-id]') || node.querySelector('a[href]');
    }
    function moveFocus(list, at) {
      var i, t = null;
      if (!grid.hidden) {
        for (i = at + 1; i < list.length && !t; i++) t = focusIn(list[i]);
        for (i = at - 1; i >= 0 && !t; i--) t = focusIn(list[i]);
      }
      t = t || el('.lkc-wl-title');
      try { if (t) t.focus(); } catch (e) { /* ignore */ }
    }

    /* Share link: this page with the saved handles in saved order. Handles come from data-wl-handles (updated when
       a product URL redirects) or the ones the core remembered; ids without a valid handle are left out.
       T6.32e (19 Sep 2026): copied from a theme preview (Shopify.theme.role is not "main"), the link also carries
       &preview_theme_id=<that theme>, so it opens the same preview in another browser. Warwick's test link opened the
       live theme, which has no wishlist template yet, and looked empty. The live theme's link is unchanged, and the
       shared view only reads shared= (the switch at the top of sections/wishlist.liquid stops at the next &). */
    function shareLink() {
      var hs = [], th = window.Shopify && window.Shopify.theme, q = '';
      W.list().forEach(function (id) {
        var h = String(handleOf(id) || '').toLowerCase();
        if (hs.length < SHARE_MAX && HANDLE.test(h) && hs.indexOf(h) < 0) hs.push(h);
      });
      if (th && typeof th.role === 'string' && th.role !== 'main' && /^\d+$/.test(String(th.id))) q = '&preview_theme_id=' + th.id;
      return { url: 'https://' + location.host + '/pages/wishlist?shared=' + hs.join(',') + q, n: hs.length };
    }
    function share(btn) {
      var s = shareLink(), back = d.activeElement;
      if (!s.n) return; /* no saved product has a handle to share (sync() hides the button then) */
      /* Next task, like the heart clicks in lkc-wishlist.js: the lazy GTM loader creates dataLayer when the click reaches window. */
      function track() {
        setTimeout(function () {
          if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: 'lkc_wishlist', action: 'share', count: s.n });
        }, 0);
      }
      function copied() {
        if (shareLabel) {
          shareLabel.textContent = 'Link copied';
          clearTimeout(copyTimer);
          copyTimer = setTimeout(function () { shareLabel.textContent = shareText; }, 2500);
        }
        W.toast('Link copied. Send it to a friend.');
        track();
      }
      /* Both copy methods blocked (some in-app browsers): show the link selected so it can be copied by hand. */
      function manual() {
        var wrap = btn.closest('[data-wl-share]') || btn.parentNode, box = wrap.querySelector('[data-wl-share-manual]'), input;
        if (!box) {
          box = d.createElement('label');
          box.className = 'lkc-wl-share__manual';
          box.setAttribute('data-wl-share-manual', '');
          box.innerHTML = '<span>Copy this link to share your wishlist.</span><input type="text" readonly>';
          wrap.appendChild(box);
        }
        input = box.querySelector('input');
        input.value = s.url;
        try { input.focus(); input.select(); input.setSelectionRange(0, s.url.length); } catch (e) { /* still shown */ }
        track();
      }
      function legacy() {
        var ta = d.createElement('textarea'), done = false;
        try {
          ta.value = s.url;
          ta.setAttribute('readonly', '');
          ta.setAttribute('aria-hidden', 'true');
          ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px';
          d.body.appendChild(ta);
          ta.select();
          ta.setSelectionRange(0, s.url.length);
          done = !!d.execCommand('copy');
        } catch (e) { done = false; }
        if (ta.parentNode) ta.parentNode.removeChild(ta);
        try { if (back && back !== d.body && back.focus) back.focus(); } catch (e) { /* ignore */ }
        if (done) copied(); else manual();
      }
      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') navigator.clipboard.writeText(s.url).then(copied, legacy);
        else legacy();
      } catch (e) { legacy(); }
    }

    function sync() {
      try {
        var ae = d.activeElement, fi = null, before = null;
        if (ae && ae !== d.body && root.contains(ae)) {
          fi = ae.closest('[data-wl-item]');
          if (fi) before = Array.prototype.slice.call(grid.children);
        } else ae = null;
        var ids = W.list(), want = ids.slice(0, shown), have = {}, prev = null, gone = 0, n = ids.length, x, h;
        xify(grid);
        each(grid.querySelectorAll('[data-wl-item],[data-wl-ph]'), function (node) {
          var id = +node.getAttribute('data-wl-item');
          if (!id || have[id] || missing[id] || failed[id] || want.indexOf(id) < 0) node.parentNode.removeChild(node);
          else have[id] = node;
        });
        want.forEach(function (id) {
          var node = have[id], h, at;
          if (missing[id] || failed[id]) return;
          if (!node) {
            h = handleOf(id);
            if (!h) { if (server[id]) missing[id] = 1; return; }
            node = skeleton();
            node.setAttribute('data-wl-item', id);
            cards.add({ id: id, h: h, n: node });
          }
          at = prev ? prev.nextElementSibling : grid.firstElementChild;
          if (at !== node) grid.insertBefore(node, at);
          prev = node;
        });
        cards.pump();
        ids.forEach(function (id) { if (missing[id]) gone++; });
        if (el('[data-wl-label]')) el('[data-wl-label]').textContent = n ? n + (n === 1 ? ' item' : ' items') : '';
        if (el('[data-wl-n]')) el('[data-wl-n]').textContent = n;
        if (el('[data-wl-missing-text]')) {
          el('[data-wl-missing-text]').textContent = gone === 1 ? '1 saved item is not available right now.' : gone + ' saved items are not available right now.';
        }
        if ((x = el('[data-wl-share-manual] input')) && x.value !== (h = shareLink().url)) x.value = h; /* keep a shown link current */
        show(el('[data-wl-missing]'), gone > 0);
        show(el('[data-wl-all]'), n > 0);
        /* Share needs at least one handle for the link: saved products that were deleted before this device learned
           their handle would otherwise copy an empty link. */
        show(el('[data-wl-share]'), n > 0 && ids.some(function (id) { return HANDLE.test(String(handleOf(id) || '').toLowerCase()); }));
        show(el('[data-wl-banner]'), n > 0);
        show(el('[data-wl-more]'), more && n > shown);
        show(el('[data-wl-empty]'), n === 0);
        show(grid, n > 0);
        if (ae && d.activeElement !== ae) {
          if (root.contains(ae) && !ae.closest('[hidden]')) ae.focus(); /* card only moved */
          else if (fi) moveFocus(before, before.indexOf(fi));
        }
        sa.refresh();
      } catch (e) { /* ignore */ }
    }

    root.addEventListener('click', function (e) {
      var t = e.target, x, had, items;
      if (!t || !t.closest) return;
      if ((x = t.closest('[data-wl-share-btn]'))) {
        e.preventDefault();
        share(x);
        return;
      }
      if ((x = t.closest('[data-wl-more-btn]'))) {
        had = d.activeElement === x;
        items = grid.querySelectorAll('[data-wl-item]');
        shown += STEP;
        sync();
        /* The button hides after the last step: continue from the last card that was already showing. */
        if (had && x.closest('[hidden]') && items.length) moveFocus([items[items.length - 1]], -1);
        return;
      }
      if ((x = t.closest('[data-wl-clean]'))) {
        had = d.activeElement === x;
        Object.keys(missing).forEach(function (id) { W.remove(id); });
        missing = {};
        sync();
        if (had && x.closest('[hidden]')) moveFocus(Array.prototype.slice.call(grid.children), -1);
      }
    });
    d.addEventListener('lkc:wishlist:change', sync);
    sync();
  }

  /* Shared view. data-shared holds the checked handles (at most 100, in the sharer's order) and
     snippets/lkc-wishlist-skeletons.liquid already painted a placeholder for each. Every card is fetched (no
     Show more); unavailable products and repeats are dropped. Hearts are the viewer's normal save hearts. */
  function shared(root, sa) {
    var grid = root.querySelector('[data-wl-sgrid]'), empty = root.querySelector('[data-wl-sempty]'), seen = {}, cards, ph, i;
    if (!grid) return;
    var list = (root.getAttribute('data-shared') || '').split(',').filter(function (h) { return HANDLE.test(h); }).slice(0, SHARE_MAX);
    function drop(node) { if (node.parentNode) node.parentNode.removeChild(node); }
    function settle() {
      cards.pump();
      if (cards.idle() && !grid.querySelector('[data-wl-item]')) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
      }
      sa.refresh();
    }
    cards = loader(function (job, item) {
      var id = item && +item.getAttribute('data-wl-item');
      if (id && !seen[id] && job.n.parentNode) { seen[id] = 1; job.n.parentNode.replaceChild(item, job.n); }
      else drop(job.n);
    }, function (job) { drop(job.n); }, settle);
    ph = grid.querySelectorAll('[data-wl-ph]');
    list.forEach(function (h, at) { cards.add({ h: h, n: ph[at] || grid.appendChild(skeleton()) }); });
    for (i = list.length; i < ph.length; i++) drop(ph[i]);
    settle();
  }

  function start() {
    var W = window.LKCWishlist, roots = d.querySelectorAll('[data-lkc-wl-page]'), i, root, sa, isShared;
    for (i = 0; i < roots.length; i++) {
      try {
        root = roots[i];
        isShared = root.hasAttribute('data-shared');
        /* T6.31c: card selects + Add to cart, and Set for all on the grid this root shows */
        cardEvents(root);
        sa = setAll(root, root.querySelector(isShared ? '[data-wl-sgrid]' : '[data-wl-grid]'));
        if (isShared) { shared(root, sa); continue; }
        if (W && W.handleOf) { setup(root, W, sa); continue; }
        /* Wishlist script missing or switched off: clear the guest skeletons, hide Share, show the empty state. */
        each(root.querySelectorAll('[data-wl-ph]'), function (n) { n.parentNode.removeChild(n); });
        var share = root.querySelector('[data-wl-share]');
        if (share) share.hidden = true;
        if (!root.querySelector('[data-wl-item]')) {
          var empty = root.querySelector('[data-wl-empty]'), grid = root.querySelector('[data-wl-grid]');
          if (empty) empty.hidden = false;
          if (grid) grid.hidden = true;
        }
        sa.refresh();
      } catch (e) { /* ignore */ }
    }
  }
  /* This file loads (defer) from inside <main>, so it runs BEFORE the deferred lkc-wishlist.js near the end of
     <body>, while readyState is already "interactive". Every deferred script has run by DOMContentLoaded, so
     wait for that unless the core is already here. */
  var started = false;
  function go() { if (!started) { started = true; start(); } }
  if (window.LKCWishlist || d.readyState === 'complete') go();
  else { d.addEventListener('DOMContentLoaded', go); window.addEventListener('load', go); }
})();
